import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../images/shared/logo.svg";
import DesktopLinks from "./DesktopLinks";
import MenuButton from "./MenuButton";
import MobileMenu from "./MobileMenu";

const Nav = () => {
	const [menuOpen, setMenuOpen] = useState(false);

	return (
		<nav className='relative top-0 xl:top-10 left-0 w-full h-88 md:h-24 p-6 md:pl-10 md:pl-[55px] md:pr-0 flex items-center justify-between bg-transparent z-10'>
			<NavLink to='/'>
				<img src={logo} alt='logo' />
			</NavLink>

			<div className='w-450 h-px hidden xl:inline absolute left-[165px] bg-white opacity-25 z-20' />

			<DesktopLinks />

			<MenuButton menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
			<AnimatePresence initial={false}>
				{menuOpen && <MobileMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />}
			</AnimatePresence>
		</nav>
	);
};

export default Nav;
